module.exports = __webpack_public_path__ + "img/29_4.ef22bdaa.png";